<template>
    <div>
        <v-card-title>
            <v-spacer></v-spacer>
            <template v-if="isEmployee">
                <v-btn
                    medium
                    color="primary"
                    :loading="btnDisable"
                    :disabled="!valid"
                    @click.prevent="save()"
                >
                    {{ $t('corporate.captable.companyInfo.update') }}
                </v-btn>
            </template>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-card-text class="pb-0">
                <v-row>
                    <v-col cols="12" md="5">
                        <v-text-field
                            v-model="client.companyInfo.socialReason"
                            :label="$t('corporate.captable.companyInfo.socialReason')"
                            flat
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <input-select :setup.sync="companyType"></input-select>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-text-field
                            v-model="client.shareCapital"
                            :label="shareCapitalLabel"
                            flat
                            readonly
                            disabled
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            v-model="client.companyInfo.socialObjects"
                            :label="$t('corporate.captable.companyInfo.socialObjects')"
                            flat
                            filled
                            no-resize
                            rows="4"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            v-model="client.companyInfo.CNAES"
                            :label="$t('corporate.captable.companyInfo.CNAES')"
                            flat
                            filled
                            no-resize
                            rows="4"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-text-field
                            v-model="client.companyInfo.headquarters"
                            :label="$t('corporate.captable.companyInfo.headquarters')"
                            fat
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <input-date-picker-day-month :setup.sync="meetingDate"></input-date-picker-day-month>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-form>
    </div>
</template>

<script>
import API from '@/api'
import InputSelect from '@/components/InputSelect'
import InputDatePickerDayMonth from '@/components/InputDatePickerDayMonth'

export default {
    name: 'company-info',
    components: {
        InputSelect,
        InputDatePickerDayMonth
    },
    props: ['client'],
    data: function () {
        return {
            btnDisable: false,
            loading: false,
            valid: false,
            companyType: {
                label: this.$t('corporate.captable.companyInfo.companyType.label'),
                text: 'label',
                value: 'value',
                required: true,
                readonly: false,
                filled: true,
                multiple: false,
                rule: [
                    v => !!v || this.$t('corporate.captable.companyInfo.companyType.required')
                ],
                items: [
                    { value: 1, label: this.$t('corporate.captable.companyInfo.companyType.items.sa') },
                    { value: 2, label: this.$t('corporate.captable.companyInfo.companyType.items.ltda') }
                ],
                selectedItems: 1
            },
            meetingDate: {
                label: this.$t('corporate.captable.companyInfo.meetingDate.label'),
                rule: [
                    v => !!v || this.$t('corporate.captable.companyInfo.meetingDate.required')
                ],
                checkDateisBeforeNow: false,
                required: true,
                readonly: false,
                clearable: false,
                filled: true,
                dateFormatted: undefined,
                dateRaw: undefined
            },
            shareCapitalLabel: this.$t('corporate.captable.companyInfo.shareCapitalLabel')
        }
    },
    watch: {
        'companyType.selectedItems' () {
            this.shareCapitalLabel = this.companyType.selectedItems === 1 ? this.$t('corporate.captable.companyInfo.totalActions') : this.$t('corporate.captable.companyInfo.totalQuotas')
            this.meetingDate.label = this.companyType.selectedItems === 1 ? this.$t('corporate.captable.companyInfo.agoDate') : this.$t('corporate.captable.companyInfo.partnersMeetingDate')
        }
    },
    mounted () {
        if (this.client.companyInfo && this.client.companyInfo.meetingDate) {
            this.meetingDate.dateFormatted = this.$options.filters.momentFormatDateNoISO(this.client.companyInfo.meetingDate, 'D - MMM').toUpperCase()
            this.meetingDate.dateRaw = this.client.companyInfo.meetingDate
        }
        if (this.client.companyInfo && this.client.companyInfo.meetingDate) {
            this.companyType.selectedItems = this.client.companyInfo.companyType
        }
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        async save () {
            this.btnDisable = true
            if (this.$refs.form.validate()) {
                this.valid = false

                this.client.companyInfo.companyType = this.companyType.selectedItems
                this.client.companyInfo.meetingDate = this.meetingDate.dateRaw

                let endpoint = API.EndPoints.saveCompanyInfo
                let params = {
                    objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioCaptable', this.$route.params.id),
                    companyInfo: this.client.companyInfo
                }
                await new API(endpoint, params).request().then(response => {
                    this.client.companyInfo = response.data.result.companyInfo
                    this.client.shareCapital = response.data.result.shareCapital
                    this.btnDisable = false
                    this.valid = true
                }, (e) => {
                    this.$helpers.requestError(e)
                })
            } else {
                this.btnDisable = false
                this.valid = true
            }
        }
    }
}
</script>
